import React, { useEffect, useState } from 'react';

// COMPONENTS
import Icon from '../Icon/Icon';
import Button from '../Button';

// INTERFACES
import { IToastProps } from '../../interfaces/Toast.interface';

// ENUMS
import { Alignments } from '../../enums/alignments';
import { Icons } from '../../enums/icons';
import { ToastThemes } from '../../enums/toastThemes';
import { Sizes } from '../../enums/sizes';

// STYLES
import { Container, Content, IconWrapper, Action, ActionLabel, ActionIcon } from './styles';

const Toast: React.FC<IToastProps> = ({
  icon,
  children,
  actionLabel,
  themeProp = ToastThemes.LIGHT,
  align = Alignments.RIGHT_BOTTOM,
  active = true,
  onClick,
  size = Sizes.SMALL,
  actionToast,
  actionText = 'Action Text',
  timeoutCallback
}: IToastProps) => {
  const [isActive, setIsActive] = useState(active);

  useEffect(() => {
    if (!actionToast) {
      setTimeout(() => {
        if (!!timeoutCallback) {
          timeoutCallback();
        }
        setIsActive(!active);
      }, 3000);
    }
  }, [active]);

  return (
    <>
      {isActive && (
        <Container themeProp={themeProp} align={align} active={isActive} size={size}>
          <Content>
            {icon != null && (
              <IconWrapper themeProp={themeProp} actionToast={actionToast}>
                <Icon type={icon} />
              </IconWrapper>
            )}
            {children}
          </Content>
          <Action>
            {actionLabel != null && <ActionLabel onClick={onClick}>{actionLabel}</ActionLabel>}
            <ActionIcon themeProp={themeProp} actionLabel={actionLabel} onClick={onClick}>
              {!actionToast ? (
                <Icon type={Icons.CLOSE} />
              ) : (
                <Button blue hoverWhite onClick={onClick}>
                  {actionText}
                </Button>
              )}
            </ActionIcon>
          </Action>
        </Container>
      )}
    </>
  );
};

export default Toast;
